// Utility functions for exporting prestaciones data

/**
 * Export prestaciones to CSV
 * @param {Object} prestaciones - Prestaciones data
 */
export function exportPrestacionesCSV(prestaciones) {
  const headers = ['Campo', 'Valor'];
  const rows = [
    ['Empleado', `${prestaciones.empleado.nombre} ${prestaciones.empleado.apellido}`],
    ['ID', prestaciones.empleado.employeeId],
    ['Cargo', prestaciones.empleado.cargo],
    ['Departamento', prestaciones.empleado.departamento || 'N/A'],
    [''],
    ['Tiempo de Servicio', `${prestaciones.anosServicio} años ${prestaciones.mesesServicio} meses`],
    ['Salario Actual', `RD$ ${prestaciones.salarioActual.toFixed(2)}`],
    ['Salario Promedio', `RD$ ${prestaciones.salarioPromedio.toFixed(2)}`],
    [''],
    ['Vacaciones - Días', prestaciones.vacaciones.dias],
    ['Vacaciones - Días a Pagar', prestaciones.vacaciones.diasPago.toFixed(1)],
    ['Vacaciones - Monto', `RD$ ${prestaciones.vacaciones.monto.toFixed(2)}`],
    [''],
    ['Salario Navidad - Monto', `RD$ ${prestaciones.salarioNavidad.monto.toFixed(2)}`],
    [''],
    ['Preaviso - Días', prestaciones.preaviso.dias],
    ['Preaviso - Monto', `RD$ ${prestaciones.preaviso.monto.toFixed(2)}`],
    [''],
    ['Cesantía - Días', prestaciones.cesantia.dias.toFixed(1)],
    ['Cesantía - Monto', `RD$ ${prestaciones.cesantia.monto.toFixed(2)}`],
    [''],
    ['TOTAL PRESTACIONES', `RD$ ${prestaciones.totalPrestaciones.toFixed(2)}`]
  ];
  
  // Add BOM for proper UTF-8 encoding in Excel
  const csv = '\ufeff' + [headers, ...rows].map(r => r.join(',')).join('\n');
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  const filename = `prestaciones_${prestaciones.empleado.nombre}_${new Date().toISOString().split('T')[0]}.csv`;
  link.download = filename;
  link.click();
}

/**
 * Export prestaciones to HTML (for printing/PDF)
 * @param {Object} prestaciones - Prestaciones data
 * @param {String} fechaSalida - Custom exit date (optional)
 */
export function exportPrestacionesHTML(prestaciones, fechaSalida = null) {
  const html = `
<!DOCTYPE html>
<html lang="es">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Prestaciones Laborales - ${prestaciones.empleado.nombre} ${prestaciones.empleado.apellido}</title>
  <style>
    @media print {
      @page { margin: 0.8cm; }
      body { margin: 0; padding: 0; }
      .container { padding: 15px !important; box-shadow: none; }
      h1 { font-size: 20px !important; margin-bottom: 5px !important; }
      h2 { font-size: 16px !important; margin-top: 15px !important; margin-bottom: 8px !important; padding-bottom: 5px !important; }
      .header-info { padding: 12px !important; margin: 10px 0 !important; }
      .header-info p { margin: 4px 0 !important; font-size: 13px !important; }
      table { margin: 10px 0 !important; }
      th, td { padding: 8px 10px !important; font-size: 13px !important; }
      .legal-note { padding: 10px !important; margin: 12px 0 !important; font-size: 12px !important; }
      .footer { margin-top: 15px !important; padding-top: 10px !important; font-size: 11px !important; }
      .footer p { margin: 3px 0 !important; }
    }

    body {
      font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
      padding: 20px;
      max-width: 900px;
      margin: 0 auto;
      background: #f9fafb;
    }

    .container {
      background: white;
      padding: 30px;
      border-radius: 8px;
      box-shadow: 0 1px 3px rgba(0,0,0,0.1);
    }

    h1 {
      color: #7c3aed;
      margin-bottom: 8px;
      font-size: 24px;
    }

    h2 {
      color: #1f2937;
      margin-top: 20px;
      margin-bottom: 12px;
      font-size: 18px;
      border-bottom: 2px solid #e5e7eb;
      padding-bottom: 8px;
    }

    .header-info {
      background: #f3f4f6;
      padding: 15px;
      border-radius: 6px;
      margin: 15px 0;
    }

    .header-info p {
      margin: 6px 0;
      color: #4b5563;
      font-size: 14px;
    }
    
    .header-info strong {
      color: #1f2937;
    }
    
    table {
      width: 100%;
      border-collapse: collapse;
      margin: 15px 0;
    }

    th {
      background-color: #7c3aed;
      color: white;
      padding: 10px;
      text-align: left;
      font-weight: 600;
      font-size: 14px;
    }

    td {
      padding: 10px;
      border-bottom: 1px solid #e5e7eb;
      color: #4b5563;
      font-size: 14px;
    }
    
    tr:hover {
      background-color: #f9fafb;
    }
    
    .total-row {
      background-color: #ede9fe !important;
      font-weight: bold;
      font-size: 1.1em;
    }
    
    .total-row td {
      color: #7c3aed;
      border-top: 2px solid #7c3aed;
      border-bottom: 2px solid #7c3aed;
    }
    
    .amount {
      text-align: right;
      font-weight: 600;
    }
    
    .footer {
      margin-top: 20px;
      padding-top: 12px;
      border-top: 1px solid #e5e7eb;
      font-size: 0.85em;
      color: #6b7280;
    }

    .footer p {
      margin: 4px 0;
    }

    .legal-note {
      background: #fef3c7;
      border-left: 4px solid #f59e0b;
      padding: 12px;
      margin: 15px 0;
      font-size: 0.85em;
      line-height: 1.4;
    }
    
    @media print {
      .no-print {
        display: none;
      }
    }
  </style>
</head>
<body>
  <div class="container">
    <h1>📋 Cálculo de Prestaciones Laborales</h1>
    <p style="color: #6b7280; margin-bottom: 15px; font-size: 13px;">Código de Trabajo Dominicano</p>
    
    <div class="header-info">
      <p><strong>Empleado:</strong> ${prestaciones.empleado.nombre} ${prestaciones.empleado.apellido}</p>
      <p><strong>ID:</strong> ${prestaciones.empleado.employeeId}</p>
      <p><strong>Cargo:</strong> ${prestaciones.empleado.cargo}</p>
      <p><strong>Departamento:</strong> ${prestaciones.empleado.departamento || 'N/A'}</p>
      <p><strong>Tiempo de Servicio:</strong> ${prestaciones.anosServicio} años y ${prestaciones.mesesServicio} meses</p>
      <p><strong>Salario Actual:</strong> RD$ ${prestaciones.salarioActual.toLocaleString('es-DO', {minimumFractionDigits: 2})}</p>
      <p><strong>Salario Promedio (12 meses):</strong> RD$ ${prestaciones.salarioPromedio.toLocaleString('es-DO', {minimumFractionDigits: 2})}</p>
    </div>
    
    <h2>Desglose de Prestaciones</h2>
    <table>
      <thead>
        <tr>
          <th>Concepto</th>
          <th style="text-align: center;">Días</th>
          <th style="text-align: right;">Monto (RD$)</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td><strong>Vacaciones</strong><br><small>Art. 178 Código de Trabajo</small></td>
          <td style="text-align: center;">${prestaciones.vacaciones.diasPago.toFixed(1)}</td>
          <td class="amount">RD$ ${prestaciones.vacaciones.monto.toLocaleString('es-DO', {minimumFractionDigits: 2})}</td>
        </tr>
        <tr>
          <td><strong>Salario de Navidad</strong><br><small>Ley 491-08</small></td>
          <td style="text-align: center;">-</td>
          <td class="amount">RD$ ${prestaciones.salarioNavidad.monto.toLocaleString('es-DO', {minimumFractionDigits: 2})}</td>
        </tr>
        <tr>
          <td><strong>Preaviso</strong><br><small>Art. 75-80 Código de Trabajo</small></td>
          <td style="text-align: center;">${prestaciones.preaviso.dias}</td>
          <td class="amount">RD$ ${prestaciones.preaviso.monto.toLocaleString('es-DO', {minimumFractionDigits: 2})}</td>
        </tr>
        <tr>
          <td><strong>Cesantía</strong><br><small>Art. 82 Código de Trabajo</small></td>
          <td style="text-align: center;">${prestaciones.cesantia.dias.toFixed(1)}</td>
          <td class="amount">RD$ ${prestaciones.cesantia.monto.toLocaleString('es-DO', {minimumFractionDigits: 2})}</td>
        </tr>
        <tr class="total-row">
          <td colspan="2"><strong>TOTAL A PAGAR</strong></td>
          <td class="amount"><strong>RD$ ${prestaciones.totalPrestaciones.toLocaleString('es-DO', {minimumFractionDigits: 2})}</strong></td>
        </tr>
      </tbody>
    </table>
    
    <div class="legal-note">
      <strong>⚠️ Nota Legal:</strong> Este cálculo es referencial y está basado en el Código de Trabajo de la República Dominicana. 
      Los valores están calculados según los últimos 12 salarios cotizables del empleado. 
      Se recomienda consultar con un abogado laboralista para validación oficial.
    </div>
    
    <div class="footer">
      <p><strong>Fecha de emisión:</strong> ${new Date().toLocaleDateString('es-DO', {year: 'numeric', month: 'long', day: 'numeric'})}</p>
      ${fechaSalida ? `<p><strong>Fecha de cálculo:</strong> ${new Date(String(fechaSalida).split('T')[0] + 'T12:00:00').toLocaleDateString('es-DO', {year: 'numeric', month: 'long', day: 'numeric'})}</p>` : ''}
      <p><strong>Sistema:</strong> 7Family HR - Módulo de Prestaciones</p>
    </div>
    
    <div class="no-print" style="text-align: center; margin-top: 30px;">
      <button onclick="window.print()" style="background: #7c3aed; color: white; border: none; padding: 12px 24px; border-radius: 6px; cursor: pointer; font-size: 16px;">
        🖨️ Imprimir / Guardar como PDF
      </button>
    </div>
  </div>
  
  <script>
    // Auto-print on load (can be commented out if not desired)
    window.onload = function() {
      setTimeout(function() {
        window.print();
      }, 500);
    };
  </script>
</body>
</html>
  `;
  
  const win = window.open('', '_blank');
  win.document.write(html);
  win.document.close();
}
